export default "__VITE_ASSET__DMCjoVpQ__"